module.exports = __webpack_public_path__ + "img/pd-img-face4.5db2fe60.png";